import Event from '../../core/Event';
import { OrderDocumentType } from '../../../view/order/UserOrder';

export default class OrderDocumentRequested extends Event {
    public static type = 'OrderDocumentRequested';

    constructor(public readonly documentType: OrderDocumentType, public readonly documentId: string, public readonly customerId: string) {
        super(OrderDocumentRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderDocumentRequested.ts